"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const react_1 = require("react");
const useSelfUpdatingRef_1 = __importDefault(require("./useSelfUpdatingRef"));
function useIntermediateState(value, onChange, immediateApply = false) {
    const [intermediateState, setIntermediateState] = (0, react_1.useState)(value);
    const intermediateStateRef = (0, useSelfUpdatingRef_1.default)(intermediateState);
    const applyHandler = () => {
        onChange(intermediateStateRef.current);
    };
    return {
        isChanged: immediateApply ? false : !(0, isEqual_1.default)(value, intermediateState),
        value: immediateApply ? value : intermediateState,
        onChange: immediateApply ? onChange : setIntermediateState,
        onApply: applyHandler,
    };
}
exports.default = useIntermediateState;
//# sourceMappingURL=useIntermediateState.js.map